import React from "react";

const Otherd =()=>
{
    return(
        <>
        <section>
<div className="container pb-5">
<div className="bfc-advantage-title text-center py-5">
        <h1>What  <div className="sub-color d-inline-block">We Offer</div> That Others Don't </h1>    
        </div>
        <div className="row justify-content-center other wrapper">
            <div className="col-md-6 col-lg-3 px-0 mx-smc-2 box">
               <img src="/assets/img/New folder/Committed Team.png" alt="" className="img-fluid" />
               <h5 className="pt-4 color-bluec">Committed Team</h5>
                   <p className="text-justify px-3 pb-3">Our team stays committed to the success of your project until its completion, so much so that it takes ownership of the assigned task, ensuring results that match your expectations</p>
            </div>
       
            <div className="col-md-6 col-lg-3 px-0  ml-3 mx-smc-2 box">
               <img src="/assets/img/New folder/Flexible Methodology.png" alt=""className="img-fluid" />
               <h5 className="pt-4 color-bluec">Flexible Methodology </h5>
                   <p className="text-justify px-3 pb-3">We have an agile approach to projects, which helps us actively adapt to your evolving business needs. Meaning, we are readily adjusting our strategy to produce pleasing outcomes.</p>
            </div>
               
            <div className="col-md-6 col-lg-3 px-0 pt-2 ml-mdc-0 ml-3 mx-smc-2 box">
               <img src="/assets/img/New folder/Client-Centric Approach.png" alt="" className="img-fluid " />
               <h5 className="pt-4 color-bluec ">Client-Centric Approach</h5>
                   <p className="text-justify px-3 pb-3">Our development processes are designed to actively accommodate client feedbacks. We work with you in close collaboration, ensuring that the final output is an exact interpretation of your vision. </p>
            </div>
       
            <div className="col-md-6 col-lg-3 px-0 ml-3 mx-smc-2 box">
               <img src="/assets/img/New folder/Cutting-edge Solutions.png" alt=""className="img-fluid pb-2" />
               <h5 className="pt-4 color-bluec">Cutting-edge Solutions</h5>
                   <p className="text-justify px-3 pb-3">We employ the best industry practices and latest development techniques to develop bespoke solutions for your business, helping you streamline your operations and find online success.</p>
            </div>
        </div>
</div>

        </section>
        
        
        </>
    )
}
export default Otherd